export const USER_EMAIL = 'email-id';
export const USER_ROLES = 'roles';
